import '@mdi/font/css/materialdesignicons.css'
import '@vuepic/vue-datepicker/dist/main.css'
import { createVuetify } from 'vuetify'
import { Intersect } from 'vuetify/directives'
import * as directives from 'vuetify/directives'
import defaultsBase from './defaults'
import theme from './theme'
import date from './date'

// Styles
import 'vuetify/styles'

let defaults = defaultsBase

if ('test' === process.env.NODE_ENV) {
  defaults = {
    ...defaults,
    VTooltip: {
      attach: true,
    },
  }
}

export default createVuetify({
  defaults,
  theme,
  date,
  directives: {
    ...directives,
    intersect: Intersect,
  },
})
